import React from 'react';
import { Input, Button, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';

interface QueryParamsProps {
  itemFrom: string;
  itemTo: string;
  dateFrom: string;
  dateTo: string;
  loading: boolean;
  onItemFromChange: (v: string) => void;
  onItemToChange: (v: string) => void;
  onDateFromChange: (v: string) => void;
  onDateToChange: (v: string) => void;
  onQuery: () => void;
}

const QueryParams: React.FC<QueryParamsProps> = ({
  itemFrom, itemTo, dateFrom, dateTo, loading,
  onItemFromChange, onItemToChange,
  onDateFromChange, onDateToChange, onQuery,
}) => {
  const handleDateFromChange = (_: Dayjs | null, dateString: string | string[]) => {
    const val = Array.isArray(dateString) ? dateString[0] : dateString;
    onDateFromChange(val || '');
  };

  const handleDateToChange = (_: Dayjs | null, dateString: string | string[]) => {
    const val = Array.isArray(dateString) ? dateString[0] : dateString;
    onDateToChange(val || '');
  };

  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      {/* Row 1: Product code range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>產品代號[從]</span>
          <Input
            value={itemFrom}
            onChange={(e) => onItemFromChange(e.target.value.toUpperCase())}
            placeholder="起"
            style={{ width: 140 }}
            maxLength={12}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={itemTo}
            onChange={(e) => onItemToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 140 }}
            maxLength={12}
          />
        </div>
      </div>

      {/* Row 2: Date range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>入庫日期[從]</span>
          <DatePicker
            value={dateFrom ? dayjs(dateFrom) : null}
            onChange={handleDateFromChange}
            style={{ width: 140 }}
            placeholder="起始日期"
          />
          <span className="text-sm">[至]</span>
          <DatePicker
            value={dateTo ? dayjs(dateTo) : null}
            onChange={handleDateToChange}
            style={{ width: 140 }}
            placeholder="結束日期"
          />
        </div>
      </div>

      {/* Query button */}
      <div className="flex gap-2">
        <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
